// Central site configuration — single source of truth for identity, nav, SEO.

export const SITE = {
  name: 'MitoHacker',
  shortName: 'MitoHacker',
  url: 'https://mitohacker.com',
  defaultTitle: 'MitoHacker: The Science of Cellular Energy',
  description:
    'Evidence-based guides to mitochondrial health, cellular energy and longevity. Honest science on supplements, peptides, training and light, written for humans.',
  ogImage: 'https://mitohacker.com/og-default.jpg',
  locale: 'en_US',
  wpApi: '/wp-json',
  twitter: '@mitohacker',
  youtube: 'https://www.youtube.com/@Mito-Hacker',
} as const

export const NAV_LINKS = [
  { label: 'Articles', href: '/articles' },
  { label: 'Supplements', href: '/supplements' },
  { label: 'About', href: '/about' },
  { label: 'Contact', href: '/contact' },
] as const

export const FOOTER_LINKS: { title: string; links: { label: string; href: string }[] }[] = [
  {
    title: 'Learn',
    links: [
      { label: 'Knowledge Hub', href: '/learn' },
      { label: 'All Articles', href: '/articles' },
      { label: 'Supplements', href: '/supplements' },
      { label: 'Peptides', href: '/peptides' },
      { label: 'Leaderboard', href: '/leaderboard' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About', href: '/about' },
      { label: 'Contact', href: '/contact' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Medical Disclaimer', href: '/medical-disclaimer' },
      { label: 'Privacy Policy', href: '/privacy' },
      { label: 'Terms of Use', href: '/terms' },
    ],
  },
]

export const SOCIAL_LINKS: { label: string; href: string }[] = [
  // Placeholders — wire real handles when ready.
  { label: 'X', href: 'https://x.com' },
  { label: 'YouTube', href: SITE.youtube },
  { label: 'Instagram', href: 'https://instagram.com' },
]
